import { createSlice, current } from "@reduxjs/toolkit";
import { FeedJson } from "../../core/json/HomePageJson";
import { MediaTypeEum } from "../../core/enumerations/MediaTypeEnum";
import createStore from "../CreateStore";

export interface IHomeState {
  isLoading: boolean;
  error: string;
  success: string;
  mediaContent: any;
  isPersonalizeHomeContent: boolean;
  isBottomNavBar: boolean;
  isHomePostsFetched: boolean;
  homePosts: any;
}

const initialState: IHomeState = {
  isLoading: false,
  error: "",
  success: "",
  mediaContent: FeedJson,
  isPersonalizeHomeContent: false,
  isBottomNavBar: false,
  isHomePostsFetched: false,
  homePosts: [],
};

export const homeRedux: any = createSlice({
  name: "homeRedux",
  initialState,
  reducers: {
    setHomeState: (state: any, action: any) => {
      const newState = {
        ...state,
      };
      newState[action.payload.key] = action.payload.value;
      return newState;
    },

    resetHomeState: (state: any) => {
      const newState = {
        ...state,
      };
      return newState;
    },

    // get All Home Post - api
    getHomePostRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isHomePostsFetched: true,
      };
      return newState;
    },

    getHomePostSuccess: (state: any, action: any) => {
      const { store } = createStore();

      const previousRecommendedPosts =
        store.getState()?.recommendationRedux?.recommendedPosts;

      const previousHomePosts = current(state?.homePosts);
      let modifiedHomePost = {
        ...action?.payload?.data,
        responseData: action?.payload?.data?.responseData?.map((posts: any) => {
          return {
            ...posts,
            interestRate: 50,
            postMedias: posts?.postMedias?.map((media: any) => {
              if (
                media?.mediaType === MediaTypeEum.video ||
                media?.mediaType === MediaTypeEum.audio ||
                media?.mediaType === MediaTypeEum.voice
              ) {
                return {
                  ...media,
                  isPlaying: false,
                  isMute: false,
                };
              }
              return media;
            }),
          };
        }),
      };

      const previousData =
        action?.payload?.data?.currentPage === 1
          ? previousRecommendedPosts?.length > 0
            ? previousRecommendedPosts
            : []
          : previousHomePosts?.responseData;

      const newState = {
        ...state,
        isLoading: false,
        isHomePostsFetched: false,
        homePosts: {
          ...modifiedHomePost,
          responseData: [
            ...previousData,
            ...action?.payload?.data?.responseData,
          ],
        },
      };
      return newState;
    },

    getHomePostFailure: (state: any, action: any) => {
      const response = action.payload;
      const newState = {
        ...state,
        isLoading: false,
        isHomePostsFetched: false,
        errorMessage: response,
      };
      return newState;
    },
  },
});

export const {
  setHomeState,
  resetHomeState,

  getHomePostRequest,
  getHomePostSuccess,
  getHomePostFailure,
} = homeRedux.actions;

export default homeRedux.reducer;
